// Basado en la tantidad de saltos de caracteres y saltos de lineas, indica si se debe dividir el texto.
export const shouldDivideText = ({
    text,
    minCharacters,
    minBreaksLines,
}: {
    text: string;
    minCharacters: number;
    minBreaksLines: number;
}): boolean => {
    if (!text) return false;

    if (text?.length < minCharacters) return false;

    const breakLines = (text.match(/\n/g) || []).length;

    return breakLines >= minBreaksLines;
};

export const splitRequirementsTextByLine = (requirements: string) => {
    return requirements
        ?.split("<br/>")
        ?.map((linea) => linea.trim()?.replace("-", ""));
};
